import { render, staticRenderFns } from "./ModalRemanejar.vue?vue&type=template&id=4f894c40"
import script from "./ModalRemanejar.vue?vue&type=script&lang=js"
export * from "./ModalRemanejar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports